module.exports = __webpack_public_path__ + "img/add_btn_icon491.25fe014f.svg";